import { all, put, select, takeLatest } from 'redux-saga/effects';

import * as selectors from './selectors';
import * as linksHelper from '../../lib/links';
import * as normalizers from './normalizers';
import * as FileActions from './actions';
import * as LeanLink from '../../lib/LeanLinkService';

import { keyed } from '../../lib/Actions';

export function* upload({ payload: { url, files }, key }) {
  yield put(keyed(key)(FileActions.uploadRequest)(url));
  yield LeanLink.apiCall(
    LeanLink.Mappings.postFiles({ files, url }),
    data => keyed(key)(FileActions.uploadSuccess)(normalizers.files(data), url),
    error => keyed(key)(FileActions.uploadError)(url, error),
  );
}

export function* edit({ payload: { id, name }, key }) {
  const files = yield select(selectors.files);
  const links = files.getIn([String(id), 'links']).toJS();
  const url = linksHelper.hateoas(links).get('edit');

  yield LeanLink.apiCall(
    LeanLink.Mappings.patch({ url, payload: { name } }),
    data => keyed(key)(FileActions.editSuccess)(id, data),
    keyed(key)(FileActions.editError),
  );
}

export function* remove({ payload: { id }, key }) {
  const files = yield select(selectors.files);
  const links = files.getIn([String(id), 'links']).toJS();
  const url = linksHelper.hateoas(links).get('delete');

  yield LeanLink.apiCall(
    LeanLink.Mappings.del({ url }),
    keyed(key)(FileActions.removeSuccess),
    keyed(key)(FileActions.removeError),
  );
}

export default function* defaultSaga() {
  yield all([
    takeLatest(FileActions.UPLOAD, upload),
    takeLatest(FileActions.EDIT, edit),
    takeLatest(FileActions.REMOVE, remove),
  ]);
}
